import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const EndRecurringMeetingFromMutation = graphql(`
  mutation EndRecurringMeetingFrom($seriesId: ID!, $fromOccurrenceDate: LocalDate!) {
    endRecurringMeetingFrom(seriesId: $seriesId, fromOccurrenceDate: $fromOccurrenceDate) {
      id
      __typename
      cadence
      startDate
      until
      client {
        id
        legacyId
        name
        externalReference
        __typename
      }
    }
  }
`);

export function useEndRecurringMeetingFrom() {
  const [result, endRecurringMeetingFromMutation] = useMutation(EndRecurringMeetingFromMutation);
  const [error, setError] = useState<Error | null>(null);

  const endRecurringMeetingFrom = useCallback(
    async (seriesId: string, fromOccurrenceDate: string) => {
      try {
        const response = await endRecurringMeetingFromMutation({ seriesId, fromOccurrenceDate });
        if (response.error) {
          throw response.error;
        }
        return response.data?.endRecurringMeetingFrom;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [endRecurringMeetingFromMutation],
  );

  return { endRecurringMeetingFrom, result, error };
}
